import styled from "styled-components";
import { theme } from "@themes";

export const GeneralStyle = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 28% 72%;
  overflow-x: auto;
  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
  .menu-hr {
    margin: 0;
  }
`;

export const MenuWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  height: 65px;
  overflow-x: auto;
  background-color: ${({ theme }) => theme.neutral.white};
  div:hover {
    border-bottom: 1px solid ${({ theme }) => theme.primary.purpleMedium};
  }

  #settings {
    ${({ selectedMenu }) =>
      selectedMenu === "settings" &&
      `
        color : ${({ theme }) => theme.primary.purpleMedium};
        border-bottom: 1px solid ${({ theme }) => theme.primary.purpleMedium};
        svg {
            fill: ${({ theme }) => theme.primary.purpleMedium};
        }
        svg > path {
            fill: ${({ theme }) => theme.primary.purpleMedium};
        }
      `};
    transition: background 0.2s, color 0.2s ease;
  }

  #style {
    ${({ selectedMenu, disabled }) =>
      selectedMenu === "style" &&
      `
        color : ${({ theme }) => theme.primary.purpleMedium};
        border-bottom: 1px solid ${({ theme }) => theme.primary.purpleMedium};
        svg {
            fill: ${({ theme }) => theme.primary.purpleMedium};
        }
        svg > path {
            fill: ${({ theme }) => theme.primary.purpleMedium};
        }
      `};
    transition: background 0.2s, color 0.2s ease;
  }
  #questions {
    ${({ selectedMenu, disabled }) =>
      selectedMenu === "questions" &&
      `
        color : ${({ theme }) => theme.primary.purpleMedium};
        border-bottom: 1px solid ${({ theme }) => theme.primary.purpleMedium};
        svg {
            fill: ${({ theme }) => theme.primary.purpleMedium};
        }
        svg > path {
            fill: ${({ theme }) => theme.primary.purpleMedium};
        }
      `};
    transition: background 0.2s, color 0.2s ease;
  }
  #questionbank {
    ${({ selectedMenu }) =>
      selectedMenu === "questionbank" &&
      `
        color : ${({ theme }) => theme.primary.purpleMedium};
        border-bottom: 1px solid ${({ theme }) => theme.primary.purpleMedium};
        svg {
            fill: ${({ theme }) => theme.primary.purpleMedium};
        }
        svg > path {
            fill: ${({ theme }) => theme.primary.purpleMedium};
        };
    `};
    transition: background 0.2s, color 0.2s ease;
  }
  #additional-data {
    ${({ selectedMenu }) =>
      selectedMenu === "additional-data" &&
      `
        color : ${({ theme }) => theme.primary.purpleMedium};
        border-bottom: 1px solid ${({ theme }) => theme.primary.purpleMedium};
        svg {
            fill: ${({ theme }) => theme.primary.purpleMedium};
        }
        svg > path {
            fill: ${({ theme }) => theme.primary.purpleMedium};
        };
    `};
    transition: background 0.2s, color 0.2s ease;
  }
`;

export const MenuItemWrapper = styled.div`
  display: flex;
  padding-top: 12px;
  height: 100%;
  width: 100%;
  cursor: pointer;
  text-align: center;
  flex-direction: column;
  align-items: center;
  font-size: 11px;
  justify-content: space-around;
  color: ${({ theme }) => theme.neutral.black};
  border-right: 1px solid ${({ theme }) => theme.neutral.gray[600]};
  svg {
    height: 20px;
    width: 20px;
    fill: ${({ theme }) => theme.neutral.black};
  }
  svg > path {
    fill: ${({ theme }) => theme.neutral.black};
  }
`;

export const ConfigPanel = styled.div`
  background: ${({ theme }) => theme.background.tertiary};
  overflow-y: auto;
`;
export const TemplateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 80vh;
`;
export const OnlyAssignedModal = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 65px;
  left: 0;
  background-color: rgba(100, 100, 100, 0.5);
  -webkit-transition: all ease 5s;
  transition: all ease 5s;
  z-index: 1;
`;

export const SaveTemplate = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 103px;
  height: 40px;
  background: ${({ theme }) => theme.primary.purple};
  border-radius: 4px;
  border: none;
  color: white;
  cursor: pointer;
  margin: 20px 0;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover {
    background-color: ${({ theme }) => theme.primary.purpleHover};
  }
`;
